// extracted by mini-css-extract-plugin
export default {"btop":"_44831182a7 dc9286e934 _2ffa436882","icon":"_4313eebd46 _2172442d8b","btoppink":"eed1718c5d _1992b1e210"};